import React from "react";
import { Link } from "react-router-dom";
import { DashboardLayout } from "../../../components/layout";
import { ROLE_LABELS } from "../../../config/roles";
import { getRole } from "../../../auth/roleService";

const linkCardClass =
  "block rounded-lg border border-gray-300 bg-white p-4 no-underline text-inherit transition-colors hover:border-[#064E8D] hover:shadow-md";

const FreightHub = () => {
  const roleLabel = ROLE_LABELS[getRole()] || "Admin";
  const breadcrumbs = [
    { label: roleLabel, link: "/dashboard" },
    { label: "Freight", link: "/freight" },
    { label: "Module" }
  ];

  return (
    <DashboardLayout className="relative" breadcrumbs={breadcrumbs}>
      <div className="max-w-[1400px]">
        <div className="card offers-table">
          <div className="flex justify-between items-center mb-2">
            <h3>Freight (admin)</h3>
          </div>
          <p className="text-sm text-gray-600 mb-4">
            Manage active fleet users, pending verifications, and inactive accounts. Admin APIs use
            your session role.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <Link className={linkCardClass} to="/freight/active_users">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Active users</h4>
              <p className="m-0 text-sm text-gray-500">
                Server-side grid, edit, profiling, RM assignment, documents.
              </p>
            </Link>
            <Link className={linkCardClass} to="/freight/new_users">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">New users</h4>
              <p className="m-0 text-sm text-gray-500">Pending / verification queue.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/inactive_users">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Inactive users</h4>
              <p className="m-0 text-sm text-gray-500">Re-enable or review disabled accounts.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/orders">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Orders</h4>
              <p className="m-0 text-sm text-gray-500">
                Freight lanes, quotes from transporters, approvals, and pricing.
              </p>
            </Link>
            <Link className={linkCardClass} to="/freight/rm_chats">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">RM chats</h4>
              <p className="m-0 text-sm text-gray-500">
                WhatsApp-style thread with freight users; search, attachments, and live polling.
              </p>
            </Link>
            <Link className={linkCardClass} to="/freight/form_request">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Freight form requests</h4>
              <p className="m-0 text-sm text-gray-500">
                Buyer and seller enquiry forms: search, sort, remarks, and status (pending / complete / rejected).
              </p>
            </Link>
            <Link className={linkCardClass} to="/freight/faqs">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">FAQs</h4>
              <p className="m-0 text-sm text-gray-500">Freight app questions and answers by section.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/faq_section">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">FAQ sections</h4>
              <p className="m-0 text-sm text-gray-500">Manage section names, order, and active state for FAQs.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/account_under_review">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Account under review slider</h4>
              <p className="m-0 text-sm text-gray-500">Banner images for the freight account review screen (jpg/png/gif).</p>
            </Link>
            <Link className={linkCardClass} to="/freight/profile_status">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Profile status</h4>
              <p className="m-0 text-sm text-gray-500">Master labels and colors for freight profile / review states.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/order_status">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Order status</h4>
              <p className="m-0 text-sm text-gray-500">Master labels and colors for freight order states in the app.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/vehicle_capacities">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Vehicle capacities</h4>
              <p className="m-0 text-sm text-gray-500">Master load ranges (min/max tonnes) used across freight profiling.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/service_categories">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Service categories</h4>
              <p className="m-0 text-sm text-gray-500">Master service labels and ordering for freight category mapping.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/social_media">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Social media</h4>
              <p className="m-0 text-sm text-gray-500">Links and icons (multipart) for footer / drawer socials.</p>
            </Link>
            <Link className={linkCardClass} to="/freight/app_drawer">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">App drawer</h4>
              <p className="m-0 text-sm text-gray-500">About, website URL, privacy policy and terms (HTML).</p>
            </Link>
            <Link className={linkCardClass} to="/freight/users/new">
              <h4 className="m-0 mb-2 text-base font-semibold text-gray-900">Create freight user</h4>
              <p className="m-0 text-sm text-gray-500">
                Multipart create with required PAN and Aadhaar front images.
              </p>
            </Link>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default FreightHub;
